import {authModule} from './../store/modules/auth';
import {Component, Vue} from 'vue-property-decorator';
import {User} from '@/store/modules/users';

@Component
export default class AuthUserMixin extends Vue {
  @authModule.State('user') user!: User;

  get authUserName() {
    return this.authUserFullName.split(' ')[0];
  }

  get authUserFullName() {
    return this.user?.employee?.Employee_Name || '';
  }

  get authUserEmail() {
    return this.user?.employee?.email;
  }
}
